import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Calendar } from 'lucide-react';
import { Button } from '../../components';
import { ContentHeader, FilterSection, ContentGrid, ContentCard, LoadingState, EmptyContentState } from '../../components/shared';
import { projectsService } from '../../services';
import './Projects.css';

export const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeFilter, setActiveFilter] = useState('All');

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const projectsData = await projectsService.getAllProjects();
        setProjects(projectsData);
        setFilteredProjects(projectsData);
      } catch (error) {
        console.error('Error fetching projects:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  useEffect(() => {
    let filtered = projects;

    if (searchTerm) {
      filtered = filtered.filter(project =>
        project.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.technologies?.some(tech =>
          tech.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    if (activeFilter !== 'All') {
      filtered = filtered.filter(project =>
        project.technologies?.includes(activeFilter)
      );
    }

    setFilteredProjects(filtered);
  }, [projects, searchTerm, activeFilter]);

  const allTechnologies = [...new Set(projects.flatMap(project => project.technologies || []))];
  const filterOptions = ['All', ...allTechnologies];

  return (
    <div className="projects-container">
      <div className="container">
        <ContentHeader
          title="Design Projects"
          subtitle="A collection of my design work, design thinking, and problem-solving approaches"
        />

        <FilterSection
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          searchPlaceholder="Search projects..."
          filterOptions={filterOptions}
          activeFilter={activeFilter}
          onFilterChange={setActiveFilter}
        />

        {loading ? (
          <LoadingState message="Loading projects..." />
        ) : filteredProjects.length === 0 ? (
          <EmptyContentState
            title="No projects found"
            message="Try adjusting your search terms or filters"
          />
        ) : (
          <ContentGrid>
            {filteredProjects.map((project) => (
              <ContentCard
                key={project.id}
                variant="project"
                linkTo={`/projects/${project.id}`}
                featuredImage={project.featuredImage}
                title={project.title}
                description={project.description}
                year={project.year}
                tags={project.technologies || []}
              />
            ))}
          </ContentGrid>
        )}
      </div>
    </div>
  );
};